import { showError } from 'util/errorPopupUtil';
import { getExpertId } from 'util/parseSelectors';
import makeCloudFunctionRequest from './makeCloudFunctionRequest';

export * from './businessAlertQueries';

export const markBusinessAlertAsRead = async (businessAlertId) => {
  try {
    const simplrExpertId = getExpertId();
    const params = {
      simplrExpertId,
      businessAlertId,
    };
    await makeCloudFunctionRequest('markBusinessAlertAsRead', params);
  } catch (error) {
    showError(error);
  }
};
